/*
 * Whether the explanation on top of the Team page was closed, in this browser.
 * Storage can throw in a locked-down browser; then the banner simply returns.
 */

const STORAGE_KEY = 'wundo.team.intro.dismissed';

export function teamIntroDismissed(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function dismissTeamIntro(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    /* Closed for this visit only. */
  }
}
